
export default function ServicesSection() {
  const serviceCategories = [
    {
      icon: 'ri-settings-3-line',
      title: 'Project Management',
      items: [
        'Owner\'s Representation & Program Management',
        'Design-Build & Pre-Construction Advisory',
        'Estimating • Value Engineering • Budget Control',
        'Permitting • Entitlements • Code Compliance',
        'AI Integration & Smart Building Systems'
      ]
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality & Safety',
      items: [
        'Quality Assurance / Quality Control (QA/QC)',
        'Safety Management & Sustainability Audits',
        'Commissioning & Handover Documentation',
        'LEED / Net-Zero Certification Support',
        'Claims Resolution & ADR through Primex Legal Group'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 mb-4">
            Core Services
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Comprehensive construction consultancy services from initial planning to project completion and beyond
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {serviceCategories.map((category, index) => (
            <div key={index} className="bg-slate-900/50 border border-yellow-400/20 rounded-2xl p-8 hover:border-yellow-400/40 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center mr-4">
                  <i className={`${category.icon} text-xl text-slate-900`}></i>
                </div>
                <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600">
                  {category.title}
                </h3>
              </div>
              <ul className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-slate-300 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Service Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-gradient-to-br from-yellow-400/10 to-yellow-600/10 border border-yellow-400/20 rounded-xl">
            <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-brain-line text-2xl text-slate-900"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">AI Integration</h4>
            <p className="text-slate-300">Smart building systems and AI-powered infrastructure solutions</p>
          </div>
          
          <div className="text-center p-6 bg-gradient-to-br from-yellow-400/10 to-yellow-600/10 border border-yellow-400/20 rounded-xl">
            <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-earth-line text-2xl text-slate-900"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">Sustainability</h4>
            <p className="text-slate-300">LEED certification and net-zero energy building expertise</p>
          </div>
          
          <div className="text-center p-6 bg-gradient-to-br from-yellow-400/10 to-yellow-600/10 border border-yellow-400/20 rounded-xl">
            <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-global-line text-2xl text-slate-900"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">Global Reach</h4>
            <p className="text-slate-300">International projects with local expertise and compliance</p>
          </div>
        </div>
      </div>
    </section>
  );
}
